<template>
    <div>   
        <div class="page-header">
            <h3>{{ $t('projects') }}</h3>
            <router-link :to="{name : 'admin.projects.create'}" class="btn btn-success">
                <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_project') }}
            </router-link>
        </div>

        <grid 
            :data="projects"
            :columns="columns"
            v-on:update-data="fetchData"
            v-on:row-clicked="goToProject"
            edit-route="/admin/projects"
            delete-route="/api/project"
            with-edit
            with-delete></grid>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Grid from "~/components/Grid";

export default {
    data() {
        return {
            creating: false,
            projects: null,
            editProject: 0,
            columns: [
                {'col' : 'name', 'title':'Namn'},
                {'col' : 'company.name', 'title':'Företag'},
                {'col' : 'printable_count', 'title':'artiklar'},
                {'col' : 'active', 'title':'Aktiv'},
                {'col' : 'created_at', 'title':'Skapades'},
            ]
        };
    },
    components: {
        Grid
    },
    created() {
        this.fetchData();
    },
    methods: {
        goToProject(project){
            if(project){
                this.$router.push({
                    path: '/printables', 
                    query: { project: project.id, company_id : project.company.id }
                });
            }
        },
        async deleteProject(id) {
            if(confirm(this.$t('delete_project'))){
                const { data } = await axios.delete("/api/project/" + id)
                this.projects = data;
            }
        },
        async fetchData() {
            this.error = this.projects = null;
            this.loading = true;
            
            const { data } = await axios.get("/api/project");

            this.loading = false;
            this.projects = data;
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/projects/index.vue